export enum EntityTabType {
  Events = 'EVENTS',
  Measures = 'MEASURES',
  Fields = 'FIELDS',
  Cohorts = 'COHORTS',
}

export enum EntityDropzoneType {
  Events = 'EVENTS',
  Measures = 'MEASURES',
  Fields = 'FIELDS',
  Filters = 'FILTERS',
  Cohorts = 'COHORTS',
}
